import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { toColor, getInitials } from 'utils'
import Icon from 'components/Icon'
import messages from "./messages";
import {FormattedMessage, useIntl} from "react-intl";

const TeamCard = ({ id, name, members = [] }) => {

  const short = useMemo(() => {
    const inParentheses = name.match(/\(([^)]+)\)/)

    if (inParentheses) {
      const candidate = inParentheses.pop()

      if (candidate.length < 3) {
        return candidate
      }

      return getInitials(candidate)
    }

    return getInitials(name)
  }, [name])

  return (
    <li className="col-span-1 shadow-sm rounded-sm ">
      <Link to={`/company/team/${id}/manage`} className="flex">
        <div className={`shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-sm ${toColor(short)}`}>
          { short }
        </div>
        <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-sm truncate">
          <div className="flex-1 px-4 py-2 text-sm truncate">
            <span className="text-gray-900 font-medium">{ name }</span>
            <p className="text-gray-500">{ members.length} <FormattedMessage {...messages.contacts}/></p>
          </div>
          <div className="shrink-0 pr-2 flex -space-x-2 overflow-hidden">
            { members.slice(0, 3).map(({ image, id }) => image ? (
              <img key={id} className="inline-block h-8 w-8 rounded-full ring-2 ring-white" src={image} alt="" />
            ) : (
              <div className={`inline-block h-8 w-8 rounded-full ring-2 ring-white ${toColor(short)} rounded-full flex items-center justify-center text-white font-medium text-sm`}>
                { getInitials(name) }
              </div>
            )) }
          </div>
        </div>
      </Link>
    </li>
  )
}

export default TeamCard
